import _ from 'lodash-es'
import countriesDataset from '../../datasets/global-STACKED-BAR-countries-ordered.csv'
import globalDataset from '../../datasets/global-STACKED-BAR.csv'

import { Datum } from './data-types'
import { CHALLENGES, ChallengesMap } from '../../lib/constants'

/*
  /$$$$$$   /$$$$$$  /$$   /$$ /$$   /$$ /$$$$$$$$ /$$$$$$$  /$$$$$$ /$$$$$$$$  /$$$$$$
 /$$__  $$ /$$__  $$| $$  | $$| $$$ | $$|__  $$__/| $$__  $$|_  $$_/| $$_____/ /$$__  $$
| $$  \__/| $$  \ $$| $$  | $$| $$$$| $$   | $$   | $$  \ $$  | $$  | $$      | $$  \__/
| $$      | $$  | $$| $$  | $$| $$ $$ $$   | $$   | $$$$$$$/  | $$  | $$$$$   |  $$$$$$
| $$      | $$  | $$| $$  | $$| $$  $$$$   | $$   | $$__  $$  | $$  | $$__/    \____  $$
| $$    $$| $$  | $$| $$  | $$| $$\  $$$   | $$   | $$  \ $$  | $$  | $$       /$$  \ $$
|  $$$$$$/|  $$$$$$/|  $$$$$$/| $$ \  $$   | $$   | $$  | $$ /$$$$$$| $$$$$$$$|  $$$$$$/
 \______/  \______/  \______/ |__/  \__/   |__/   |__/  |__/|______/|________/ \______/
*/

export const countriesData = countriesDataset
  .map(
    (row) =>
      _.pick(
        row,
        ...CHALLENGES,
        'country',
        'country_code',
        'lulucf_emission_mmt_co2',
        'ordered'
      ) as Datum
  )
  .sort((a, b) => a.ordered - b.ordered)
  .map(({ country, country_code, ordered, ...cs }) => ({
    country,
    country_code,
    ordered,
    ..._.mapValues(cs, (c) => (['NA', 'NaN'].includes(c as any) ? 0 : c)),
  }))

  .filter(({ country, country_code, lulucf_emission_mmt_co2, ordered, ...cs }) =>
    _.some(cs, (c) => c !== 0)
  )

  .map(({ country, country_code, lulucf_emission_mmt_co2, ordered, ...cs }) => ({
    ..._.mapValues(cs, (c) => c / 100),
    country,
    country_code,
    lulucf_emission_mmt_co2,
    ordered,
  }))

export const aplhaOrderedData = countriesData.slice().sort((a, b) => {
  if (a.country === 'United States of America') return -1
  if (b.country === 'United States of America') return 1
  return a.country.localeCompare(b.country, 'us')
})

export const selectOptions: { country: string; country_code: string }[] = [
  { country: 'Global', country_code: 'global' },
  ...aplhaOrderedData,
]

/*
  /$$$$$$  /$$        /$$$$$$  /$$$$$$$   /$$$$$$  /$$
 /$$__  $$| $$       /$$__  $$| $$__  $$ /$$__  $$| $$
| $$  \__/| $$      | $$  \ $$| $$  \ $$| $$  \ $$| $$
| $$ /$$$$| $$      | $$  | $$| $$$$$$$ | $$$$$$$$| $$
| $$|_  $$| $$      | $$  | $$| $$__  $$| $$__  $$| $$
| $$  \ $$| $$      | $$  | $$| $$  \ $$| $$  | $$| $$
|  $$$$$$/| $$$$$$$$|  $$$$$$/| $$$$$$$/| $$  | $$| $$$$$$$$
 \______/ |________/ \______/ |_______/ |__/  |__/|________/
*/

export const globalData = _.mapValues(
  globalDataset[0] as ChallengesMap<number> & { lulucf_emission_mmt_co2?: number },
  (x, k) => (k === 'lulucf_emission_mmt_co2' ? x : x / 100)
)
